// id of the field-UI element in the form for picking the visible teams. It's also the name of the field in
// formState.editState.fieldValues.permissions
export const ADMIN_EDIT_USER_FIELD_TEAMS_VISIBLE = 'viewTeamPermissions';
// id of the field-UI element in the form for picking the viewDepartmentStats. It's also the name of the field in
// formState.editState.fieldValues.permissions
export const ADMIN_EDIT_USER_FIELD_DEPARTMENT_STAT = 'departmentStatPermissions';

export const ADMIN_EDIT_USER_FIELD_FIRSTNAME = 'firstName';
export const ADMIN_EDIT_USER_FIELD_LASTNAME = 'lastName';
export const ADMIN_EDIT_USER_FIELD_EMAIL = 'email';
export const ADMIN_EDIT_USER_FIELD_TIMEZONE = 'timezone';
// id of the field-UI element in the form for picking the permission of the user. It's also the name of the field in
// this.getViewPermission(editState.formState.fieldValues)
export const ADMIN_EDIT_USER_FIELD_PERMISSION = 'permission';
// id of the field-UI element in the form for picking the role of the user. It's also the name of the field in
// editState.formState.fieldValues.userInfo
export const ADMIN_EDIT_USER_FIELD_ROLE = 'role';
// id of the field-UI element in the form for setting if the editing user is a coach or not. It's also the name of the
// field in editState.formState.fieldValues.userInfo
export const ADMIN_EDIT_USER_FIELD_IS_COACH = 'isCoach';
// id of the field-UI element in the form for toggling the editing user's global library permission. It's also the name
// of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_SHARE_LIBRARIES_GLOBALLY = 'CAN_SHARE_LIBRARIES_GLOBALLY';
// id of the field-UI element in the form for toggling the editing user's department library permission. It's also the
// name of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_SHARE_LIBRARIES_WITH_DEPARTMENTS =
  'CAN_SHARE_LIBRARIES_WITH_DEPARTMENTS';
// id of the field-UI element in the form for toggling the editing user's team library permission. It's also the
// name of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_SHARE_LIBRARIES_WITH_TEAMS =
  'CAN_SHARE_LIBRARIES_WITH_TEAMS';
// id of the field-UI element in the form for toggling the editing user's trigger share permission. It's also the name
// of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_SHARE_TRIGGERS_GLOBALLY = 'CAN_SHARE_TRIGGERS_GLOBALLY';
// id of the field-UI element in the form for toggling the editing user's trigger share permission. It's also the name
// of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_SHARE_TRIGGERS_WITH_DEPARTMENTS =
  'CAN_SHARE_TRIGGERS_WITH_DEPARTMENTS';
// id of the field-UI element in the form for toggling the editing user's trigger share permission. It's also the name
// of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_SHARE_TRIGGERS_WITH_TEAMS = 'CAN_SHARE_TRIGGERS_WITH_TEAMS';
// id of the field-UI element in the form for toggling the editing user's trigger share permission. It's also the name
// of a value in the array editState.formState.fieldValues.permissions.permissions
export const ADMIN_EDIT_USER_FIELD_CAN_TWO_WAY_SYNC = 'CAN_TWO_WAY_SYNC';

// id of the field-UI element in the form for toggling whether the editing user is 'login_enabled'/'active' or not.
// It's also a bool value in editState.formState.fieldValues.userInfo
export const ADMIN_EDIT_USER_FIELD_ACTIVE = 'active';
// id of the field-UI element in the form for toggling whether the editing user is 'archived'/'hidden' or not.
// It's also a bool value in editState.formState.fieldValues.userInfo
export const ADMIN_EDIT_USER_FIELD_HIDDEN = 'hidden';

// id of the field-UI element in the form to pick a team for the user. It's also a text value in
// editState.formState.fieldValues.userInfo
export const ADMIN_EDIT_USER_FIELD_TEAM = 'teamId';

// id of the field-UI element in the form to pick a dashboard mode for the user
export const ADMIN_EDIT_USER_FIELD_DASHBOARD_MODE = 'dashboardMode';

// slack email field
export const ADMIN_EDIT_USER_FIELD_SLACK_EMAIL = 'slackEmail';

export const ADMIN_EDIT_USER_FIELD_JOB = 'jobId';

export const ADMIN_EDIT_USER_LANGUAGE_OPTION = 'languages';

export const ADMIN_EDIT_USER_FIELD_RECORD_SCHEDULE_CALLS = 'botAutoJoinExclusion';
